import { motion } from "framer-motion";
import { Trophy, Code, Users } from "lucide-react";

export default function StatsSection() {
  return (
    <section
      className="relative bg-[#000101] text-white py-24 px-6 text-center overflow-hidden"
      id="journey"
    >
      {/* Floating Glow Particles Background */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="w-full h-full bg-gradient-to-tr from-[#0f172a]/10 to-[#00f0ff]/5 blur-3xl animate-pulse opacity-20" />
      </div>

      {/* Section Title */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="mb-12 relative z-10"
      >
        <h1 className="text-5xl font-extrabold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
          Vcode Freelance Milestones
        </h1>
        <p className="text-lg text-gray-400 mt-4 max-w-2xl mx-auto">
          Reflecting on the journey we've built with passion, purpose, and partnerships — one project at a time.
        </p>
        <div className="h-1 w-24 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto mt-6 rounded-full" />
      </motion.div>

      {/* Stats Grid */}
      <div className="relative z-10 grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
        {/* Loyal Clients */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2, type: "spring", stiffness: 100 }}
          className="group bg-gray-900 p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-cyan-400 transition duration-300 hover:shadow-cyan-500/20"
        >
          <Users className="w-10 h-10 text-cyan-400 mx-auto mb-4 group-hover:animate-pulse" />
          <h2 className="text-5xl font-bold text-white drop-shadow-md">3+</h2>
          <p className="text-base text-gray-400 mt-2">Happy Clients</p>
        </motion.div>

        {/* Completed Projects */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4, type: "spring", stiffness: 100 }}
          className="group bg-gray-900 p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-blue-400 transition duration-300 hover:shadow-blue-500/20"
        >
          <Trophy className="w-10 h-10 text-blue-400 mx-auto mb-4 group-hover:animate-pulse" />
          <h2 className="text-5xl font-bold text-white drop-shadow-md">5+</h2>
          <p className="text-base text-gray-400 mt-2">Projects Delivered</p>
        </motion.div>

        {/* Years of Code */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.6, type: "spring", stiffness: 100 }}
          className="group bg-gray-900 p-8 rounded-2xl shadow-lg border border-gray-800 hover:border-teal-400 transition duration-300 hover:shadow-teal-500/20"
        >
          <Code className="w-10 h-10 text-teal-400 mx-auto mb-4 group-hover:animate-pulse" />
          <h2 className="text-5xl font-bold text-white drop-shadow-md">2+</h2>
          <p className="text-base text-gray-400 mt-2">Years of Crafting Code</p>
        </motion.div>
      </div>

      {/* Footer Message */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.7 }}
        className="mt-16 max-w-3xl mx-auto relative z-10"
      >
        <p className="text-lg text-gray-300 leading-relaxed">
          At <span className="text-cyan-400 font-semibold">Vcode Freelance</span>, we don’t just write code — we build trust, deliver excellence, and empower ideas into scalable solutions.
        </p>
      </motion.div>
    </section>
  );
}
